import {twMerge} from "tailwind-merge";

export const Text = ({children, className}) => {
  return (
      <span className={twMerge('font-josefin mb-0', className)} >{children}</span>
  )
}
